import React, { useState, useCallback, useEffect } from 'react';
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core';
import Portal from '@material-ui/core/Portal';
import { CheckCircle, Error, Warning, Info, Close } from '@material-ui/icons';

const GlobalNotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((notification) => {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      message: notification.message,
      type: notification.type || 'info',
      duration: notification.duration || 4000,
      ...notification
    };
    
    setNotifications(prev => [...prev, newNotification]);
    
    return id;
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  }, []);

  const showNotification = useCallback((message, type = 'info', duration = null) => {
    const config = {
      success: 4000,
      error: 6000,
      warning: 5000,
      info: 4000
    };
    
    return addNotification({
      message,
      type,
      duration: duration || config[type] || config.info
    });
  }, [addNotification]);

  useEffect(() => {
    window.customNotifications = {
      showNotification,
      showSuccess: (message, duration) => showNotification(message, 'success', duration),
      showError: (message, duration) => showNotification(message, 'error', duration),
      showWarning: (message, duration) => showNotification(message, 'warning', duration),
      showInfo: (message, duration) => showNotification(message, 'info', duration),
      removeNotification
    };
  }, [showNotification, removeNotification]);

  const getConfig = (type) => {
    switch (type) {
      case 'success':
        return {
          color: '#4caf50',
          icon: <CheckCircle />
        };
      case 'error':
        return {
          color: '#f44336',
          icon: <Error />
        };
      case 'warning':
        return {
          color: '#ff9800',
          icon: <Warning />
        };
      case 'info':
      default:
        return {
          color: '#2196f3',
          icon: <Info />
        };
    }
  };

  return (
    <div>
      {children}
      <Portal container={document.body}>
        {notifications.map((notification, index) => {
          const config = getConfig(notification.type);
          
          return (
            <Snackbar
              key={notification.id}
              open={true}
              autoHideDuration={notification.duration}
              onClose={() => removeNotification(notification.id)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              style={{ 
                position: 'fixed',
                zIndex: 14000 + index,
                bottom: `${24 + (index * 80)}px`
              }}
            >
              <SnackbarContent
                style={{
                  backgroundColor: config.color,
                  color: '#fff',
                  minWidth: '300px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
                message={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: '12px', display: 'flex', alignItems: 'center' }}>
                      {config.icon}
                    </div>
                    <span>{notification.message}</span>
                  </div>
                }
                action={
                  <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={() => removeNotification(notification.id)}
                    style={{ color: '#fff' }}
                  >
                    <Close />
                  </IconButton>
                }
              />
            </Snackbar>
          );
        })}
      </Portal>
    </div>
  );
};

export default GlobalNotificationProvider;



// WEBPACK FOOTER //
// ./src/components/GlobalNotificationProvider.js